import * as types from 'modules/statistics/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = [];

const updateAllData = (_, { payload }) => payload?.content;

export default createReducer(initialState, {
  [types.FETCH_PROACTIVE_WORKS_DETAILS_STATS_SUCCESS]: updateAllData,
});
